import { AbilityBuilder } from '@casl/ability';
import { AppAbility, Role } from './define-permissions';

export const siteContextPermissions = (
  builder: AbilityBuilder<AppAbility>,
  role: Role,
  userToken: string,
) => {
  const { can } = builder;

  can('read', 'SiteTenants');

  can('read', 'OrganizationDetails');

  can('read', 'SiteAdministrators');

  can('read', 'SiteEvents');

  can('read', 'SiteReceptionDetails');

  can('read', 'SitePolls');

  can('read', 'SitePosts');

  can('read', 'SiteIndicators');

  can('read', 'SiteIndicatorTypes');

  can('read', 'SiteIndicatorsComparison');

  can('read', 'SiteApplications');

  can('read', 'SitePermissions');

  can('read', 'TenantPermissions');

  can('read', 'SiteAssets');

  can('read', 'SiteGdpr');

  can('read', 'Password');
  can('update', 'Password');

  can('read', 'SiteFaqs');

  can('read', 'SiteMessages');

  can('read', 'SiteAuditLogs');

  //hilight
  can('read', 'SitePropertyMembers');

  can('read', 'SitePropertyResidents');

  can('read', 'SitePropertyOwners');

  can('read', 'SiteMobileAppDisplayHomeScreen');

  can('read', 'SiteMobileAppDisplayAmenities');

  can('read', 'SiteMobileAppDisplayNewsfeed');

  can('read', 'SiteMobileAppDisplayPlaces');

  can('read', 'SiteMobileAppDisplayServices');

  can('read', 'SitePushNotifications');

  can('read', 'SiteGuests');

  can('read', 'SitePartnerships');

  can('read', 'SiteIssues');

  can('read', 'IssueManagers');

  can('read', 'SiteContactForm');

  can('create', 'SiteContactForm');

  can('read', 'SiteAmenities');

  can('read', 'SiteBookingRules');

  can('read', 'SiteBookings');

  can('read', 'SiteFaqs');

  if (role === 'buildingAdmin' || role === 'concierge' || role === 'master') {
    can('create', 'SiteTenants');
    can('update', 'SiteTenants');
    can('delete', 'SiteTenants');
    can('resendInvitation', 'SiteTenants');

    can('create', 'SiteEvents');
    can('update', 'SiteEvents');
    can('delete', 'SiteEvents');

    can('create', 'SiteReceptionDetails');
    can('update', 'SiteReceptionDetails');
    can('delete', 'SiteReceptionDetails');

    can('create', 'SitePolls');
    can('update', 'SitePolls');
    can('delete', 'SitePolls');

    can('create', 'SitePosts');
    can('update', 'SitePosts');
    can('delete', 'SitePosts');
    can('publish', 'SitePosts');
    can('unpublish', 'SitePosts');

    can('create', 'SiteIndicators');
    can('update', 'SiteIndicators');
    can('delete', 'SiteIndicators');

    can('create', 'SiteIndicatorTypes');
    can('update', 'SiteIndicatorTypes');
    can('delete', 'SiteIndicatorTypes');

    can('create', 'SiteIndicatorsComparison');
    can('update', 'SiteIndicatorsComparison');
    can('delete', 'SiteIndicatorsComparison');

    can('setAsDefault', 'SiteApplications');
    can('removeFromDefault', 'SiteApplications');
    can('grantPermission', 'SiteApplications');
    can('revokePermission', 'SiteApplications');

    can('grant', 'SitePermissions');
    can('revoke', 'SitePermissions');

    can('create', 'TenantPermissions');
    can('delete', 'TenantPermissions');

    can('update', 'SiteAssets');

    can('create', 'SiteGdpr');
    can('update', 'SiteGdpr');
    can('delete', 'SiteGdpr');

    can('create', 'SiteFaqs');
    can('update', 'SiteFaqs');
    can('delete', 'SiteFaqs');
    can('publish', 'SiteFaqs');
    can('unpublish', 'SiteFaqs');

    can('create', 'SiteMessages');
    can('update', 'SiteMessages');
    can('delete', 'SiteMessages');
    can('publish', 'SiteMessages');
    can('duplicate', 'SiteMessages');

    can('downloadXls', 'SiteIssues');
    can('editStatus', 'SiteIssues');

    can('create', 'IssueManagers');
    can('delete', 'IssueManagers');
    can('resendInvitation', 'IssueManagers');

    can('update', 'SitePropertyMembers');
    can('resendInvitation', 'SitePropertyMembers');
    can('block', 'SitePropertyMembers');
    can('delete', 'SitePropertyMembers');
    can('downloadXls', 'SitePropertyMembers');

    can('create', 'SitePropertyOwners');
    can('update', 'SitePropertyOwners');
    can('delete', 'SitePropertyOwners');
    can('resendInvitation', 'SitePropertyOwners');

    can('update', 'SitePropertyResidents');
    can('delete', 'SitePropertyResidents');

    can('update', 'SiteMobileAppDisplayHomeScreen');
    can('update', 'SiteMobileAppDisplayAmenities');
    can('update', 'SiteMobileAppDisplayNewsfeed');
    can('update', 'SiteMobileAppDisplayPlaces');
    can('update', 'SiteMobileAppDisplayServices');

    can('create', 'SitePushNotifications');
    can('update', 'SitePushNotifications');
    can('delete', 'SitePushNotifications');
    can('publish', 'SitePushNotifications');
    can('duplicate', 'SitePushNotifications');

    can('create', 'SiteGuests');
    can('update', 'SiteGuests');
    can('delete', 'SiteGuests');
    can('downloadXls', 'SiteGuests');

    can('create', 'SitePartnerships');
    can('update', 'SitePartnerships');
    can('delete', 'SitePartnerships');

    can('create', 'SiteAmenities');
    can('update', 'SiteAmenities');
    can('delete', 'SiteAmenities');
    can('block', 'SiteAmenities');
    can('unblock', 'SiteAmenities');

    can('create', 'SiteBookingRules');
    can('update', 'SiteBookingRules');
    can('delete', 'SiteBookingRules');

    can('create', 'SiteBookings');
    can('update', 'SiteBookings');
    can('delete', 'SiteBookings');
    can('confirmPresence', 'SiteBookings');
    can('finish', 'SiteBookings');
    can('cancel', 'SiteBookings');

    can('create', 'SiteFaqs');
    can('update', 'SiteFaqs');
    can('delete', 'SiteFaqs');
    can('publish', 'SiteFaqs');
    can('unpublish', 'SiteFaqs');
  }

  if (role === 'buildingAdmin' || role === 'master') {
    can('create', 'SiteAdministrators');
    can('updatePhoneNumber', 'SiteAdministrators');
    can('updateRole', 'SiteAdministrators', {
      userToken: { $ne: userToken },
    });
    can('delete', 'SiteAdministrators', {
      userToken: { $ne: userToken },
    });
    can('resendInvitation', 'SiteAdministrators', {
      userToken: { $ne: userToken },
    });
  }

  if (role === 'concierge') {
    can('resendInvitation', 'SiteAdministrators', {
      userToken: { $ne: userToken },
    });
  }

  if (role === 'master') {
    can('create', 'Site');
  }
};
